import { render, staticRenderFns } from "./MarketingCenter.vue?vue&type=template&id=29ef959a&"
import script from "./MarketingCenter.vue?vue&type=script&lang=js&"
export * from "./MarketingCenter.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports